"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesPosterType = exports.Navigation = exports.PulseBuilderType = exports.EngagementAction = exports.ObjectType = exports.ObjectId = exports.EventType = exports.PulseEventType = void 0;
var PulseEventType;
(function (PulseEventType) {
    PulseEventType["TRACKER_EVENT"] = "trackerEvent";
    PulseEventType["ENGAGEMENT_EVENT"] = "engagementEvent";
    PulseEventType["ROUTABLE_EVENT"] = "routableEvent";
})(PulseEventType = exports.PulseEventType || (exports.PulseEventType = {}));
var EventType;
(function (EventType) {
    EventType["VIEW"] = "View";
    EventType["ENGAGEMENT"] = "Engagement";
})(EventType = exports.EventType || (exports.EventType = {}));
var ObjectId;
(function (ObjectId) {
    ObjectId["FORM"] = "form";
    ObjectId["PAGE"] = "page";
    ObjectId["CONTENT"] = "content";
    ObjectId["ELEMENT"] = "element";
    ObjectId["CONFIRMATION"] = "confirmation";
    ObjectId["CONTENT_ELEMENT"] = "content:element";
})(ObjectId = exports.ObjectId || (exports.ObjectId = {}));
var ObjectType;
(function (ObjectType) {
    ObjectType["FORM"] = "Form";
    ObjectType["PAGE"] = "Page";
    ObjectType["CONFIRMATIOM"] = "Confirmation";
    ObjectType["SUBSCRIPTION"] = "Subscription";
    ObjectType["CONTENT"] = "Content";
    ObjectType["UIELEMENT"] = "UIElement";
    ObjectType["FRONTPAGE"] = "Frontpage";
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
var EngagementAction;
(function (EngagementAction) {
    EngagementAction["Click"] = "Click";
    EngagementAction["Zoom"] = "Zoom";
    EngagementAction["Pinch"] = "Pinch";
    EngagementAction["Swipe"] = "Swipe";
    EngagementAction["Drag"] = "Drag";
    EngagementAction["Drop"] = "Drop";
    EngagementAction["Spin"] = "Spin";
    EngagementAction["Scroll"] = "Scroll";
})(EngagementAction = exports.EngagementAction || (exports.EngagementAction = {}));
var PulseBuilderType;
(function (PulseBuilderType) {
    PulseBuilderType[PulseBuilderType["ENGAGEMENT"] = 0] = "ENGAGEMENT";
    PulseBuilderType[PulseBuilderType["PAGE_VIEW"] = 1] = "PAGE_VIEW";
    PulseBuilderType[PulseBuilderType["FORM_SUBMIT"] = 2] = "FORM_SUBMIT";
})(PulseBuilderType = exports.PulseBuilderType || (exports.PulseBuilderType = {}));
var Navigation;
(function (Navigation) {
    Navigation["NAVIGATION"] = "navigation";
    Navigation["ALTERNATIVE"] = "alternative";
    Navigation["REFRESH"] = "refresh";
    Navigation["UNKNOWN"] = "unknown";
})(Navigation = exports.Navigation || (exports.Navigation = {}));
var SalesPosterType;
(function (SalesPosterType) {
    SalesPosterType["PAID"] = "Paid";
    SalesPosterType["METER"] = "Meter";
    SalesPosterType["IP"] = "Ip";
    SalesPosterType["PERSONALISED"] = "Personalised";
})(SalesPosterType = exports.SalesPosterType || (exports.SalesPosterType = {}));
